import { Component, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataService } from '../../shared/services/data.service';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { SearchComponent as SearchBarComponent } from '../../shared/components/search-component/search-component.component';
import { SearchParcelComponent } from '../search-parcel/search-parcel.component';
import { TerminalComponent } from '../terminal/terminal.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  standalone: true,
  imports: [...PRIMENG_MODULES, SearchParcelComponent, TerminalComponent, SearchBarComponent]
})
export class SearchComponent {
  itemId: string = '';
  hasSearched: boolean = false;
  activeTab: string = 'parcel';
  parcelHasResult: boolean = true;
  terminalHasResult: boolean = true;
  private firstResultTabSet: boolean = false;
  private parcelResultReceived: boolean = false;
  private terminalResultReceived: boolean = false;
  viewersReady: boolean = false;

  @ViewChild(SearchParcelComponent) parcelSearch?: SearchParcelComponent;
  @ViewChild(TerminalComponent) terminalSearch?: TerminalComponent;

  constructor(private messageService: MessageService, private dataService: DataService) {}

  onSearch(value: string): void {
    this.dataService.updatePrintData({});
    this.itemId = value;
    this.hasSearched = !!value;
    if (!value) {
      return;
    }
    this.parcelHasResult = true;
    this.terminalHasResult = true;
    this.firstResultTabSet = false;
    this.parcelResultReceived = false;
    this.terminalResultReceived = false;
    this.viewersReady = false;
    this.activeTab = 'parcel';
    // child components render only once hasSearched flips, so defer until they exist
    setTimeout(() => {
      this.parcelSearch?.onSearchParcel(value);
      this.terminalSearch?.onSearchParcel(value);
    });
  }

  onClear(): void {
    this.dataService.updatePrintData({});
    this.itemId = '';
    this.hasSearched = false;
  }

  onParcelResult(found: boolean): void {
    this.parcelResultReceived = true;
    this.updateViewersReady();
    this.parcelHasResult = found;
    this.selectFirstTabWithResult('parcel', found);
    this.handleItemNotFound();
  }

  onTerminalResult(found: boolean): void {
    this.terminalResultReceived = true;
    this.updateViewersReady();
    this.terminalHasResult = found;
    this.selectFirstTabWithResult('terminal', found);
    this.handleItemNotFound();
  }

  private handleItemNotFound(): void {
    if (this.hasSearched && !this.parcelHasResult && !this.terminalHasResult) {
      this.hasSearched = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Item not found. Please try again.'
      });
    }
  }

  private selectFirstTabWithResult(tab: string, found: boolean): void {
    if (found && (!this.firstResultTabSet || tab === 'parcel')) {
      this.activeTab = tab;
      this.firstResultTabSet = true;
    }
  }

  private updateViewersReady(): void {
    this.viewersReady = this.parcelResultReceived && this.terminalResultReceived;
  }
}
